import _ from 'lodash';
import { updateNextPanels } from 'helpers/ContentHelper';
import {
  RESET,
  FETCH_HEADER_SEARCH,
  REFRESH_SEARCH_PANEL,
  FETCH_NEXT_SEARCH,
  FETCH_UP_NEXT_SEARCH,
  SET_FETCHING_SEARCH,
  SET_TAB,
  RESET_NEXT_PAGE,
} from './Actions';

const INITIAL_STATE = {
  panels: null,
  filteredItems: [],
  nextPage: null,
  nextPageSet: null,
  fetching: false,
  panelPaginated: [],
  selectedTab: null,
  selectedTabName: null,
  suggestedNetwork: null,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_HEADER_SEARCH: {
      const { selectedTab } = state;
      const data = _.get(action, 'payload.data', null);

      if (!data) return state;
      const { panels, member: filteredItems, SEO } = data;
      const getNextPageSet = (currentState, nextPage) =>
        currentState.nextPageSet || !!nextPage || false;

      if (filteredItems) {
        return { ...state, filteredItems: data, panelPaginated: [] };
      }
      const nextPage = _.get(panels, `member.${selectedTab + 1}.items.view.next`, null);
      const nextPageSet = getNextPageSet(state, nextPage);
      return {
        ...state,
        panels,
        SEO,
        panelPaginated: [],
        filteredItems: [],
        nextPageSet,
        nextPage,
        fetching: false,
      };
    }
    case REFRESH_SEARCH_PANEL: {
      const newPanel = _.get(action, 'payload.data', null);
      if (!newPanel) return state;
      const { panels } = state;
      panels.member = _.map(panels.member, member => {
        if (member.id === newPanel.id) {
          return newPanel;
        }
        return member;
      });
      return { ...state, panels, panelPaginated: [] };
    }
    case FETCH_NEXT_SEARCH: {
      const nextPage = _.get(action, 'payload.data.view.next');
      const newPage = _.get(action, 'payload.data.member');
      const { nextPageSet: oldNextPageSet, filteredItems, panelPaginated } = state;
      const newNextPageSet = !oldNextPageSet && nextPage ? !!nextPage : oldNextPageSet;

      const props = {
        ...state,
        nextPage,
        nextPageSet: newNextPageSet,
        fetching: false,
      };

      if (!newPage) {
        return {
          ...state,
          nextPage: null,
          fetching: false,
        };
      }
      if (filteredItems.length) {
        props.filteredItems = filteredItems.concat(newPage);
      } else {
        props.panelPaginated = panelPaginated.concat(newPage);
      }

      return props;
    }
    case FETCH_UP_NEXT_SEARCH: {
      const { panels } = state;
      const upNextVideos = _.get(action, 'payload.data.member', []);
      const newPanels = updateNextPanels({ panels, upNextVideos });
      if (!newPanels) return state;
      return {
        ...state,
        panels: newPanels,
      };
    }
    case SET_FETCHING_SEARCH: {
      const { payload: fetching } = action;
      return {
        ...state,
        fetching,
      };
    }
    case SET_TAB: {
      const { payload } = action;
      const panels = _.get(state, 'panels.member', null);
      const suggestedNetwork = _.get(state, 'suggestedNetwork', null);
      const collectionType = _.get(payload, 'collectionType', null);
      const value = _.get(payload, 'value', null);

      if (!panels) {
        return collectionType ? { ...state, suggestedNetwork: collectionType } : state;
      }

      let panel;
      let selectedTabIndex;
      if (suggestedNetwork) {
        selectedTabIndex = _.findIndex(panels, _panel => {
          panel = _panel;
          return _panel.collectionType === suggestedNetwork;
        });
      } else {
        panel = panels[value];
        selectedTabIndex = value;
      }

      if (!panel) return state;

      const nextState = {
        ...state,
        filteredItems: [],
        selectedTab: selectedTabIndex,
        selectedTabName: payload.headline,
        panelPaginated: [],
        suggestedNetwork: null,
      };
      if (!payload.selectedFilterIdx) {
        nextState.nextPage = _.get(panel, 'items.view.next', null);
        nextState.nextPageSet = !!nextState.nextPage;
      }
      return nextState;
    }
    case RESET_NEXT_PAGE: {
      return {
        ...state,
        nextPage: null,
        nextPageSet: false,
      };
    }
    case RESET: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
